/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'digitalData',
    'pip-events',
    'window'
],
function(
    pip,
    DDO,
    pipEvents,
    window
){

    function initProductNotFoundAnalytics(){
        if (pip && !pip.products.primary.data){            
            var analyticsProductNotFoundData = {
                pageInfo: {
                    pageName: 'productNotFound',
                    pageLoadEvent: 'product view',
                    pageType: 'pip'
                },
                error: [
                    {
                        type: 'advisory',
                        displayType: 'page',
                        pageSection: 'pip',
                        message: 'The product you are trying to view is not currently available. If you have any questions, you can reach our web support team by email at customercare@homedepot.com or by phone at 1-800-430-3376',
                        code: ''
                    }
                ]
            };

            if (window.digitalData && window.digitalData.page) {
                window.digitalData.page.push(analyticsProductNotFoundData);
            }
            else{
                window.digitalData.page = analyticsProductNotFoundData;                
            }
        }
    }
    
    return {
        init: function () {
            initProductNotFoundAnalytics();
        }
    }

});
}.call(window));